import { render, staticRenderFns } from "./user-select.vue?vue&type=template&id=05e2a05e&scoped=true&"
import script from "./user-select.vue?vue&type=script&lang=js&"
export * from "./user-select.vue?vue&type=script&lang=js&"
import style0 from "./user-select.vue?vue&type=style&index=0&id=05e2a05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e2a05e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e2a05e')) {
      api.createRecord('05e2a05e', component.options)
    } else {
      api.reload('05e2a05e', component.options)
    }
    module.hot.accept("./user-select.vue?vue&type=template&id=05e2a05e&scoped=true&", function () {
      api.rerender('05e2a05e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user-select.vue"
export default component.exports